var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"transaction-amount"},[_c('span',[_vm._v(_vm._s(_vm.formattedAmount))]),_vm._v(" "),_c('span',{staticClass:"nis-currency"},[_vm._v("₪")])])
}
var staticRenderFns = []

export { render, staticRenderFns }